import { Alert } from '@cmsgov/ds-medicare-gov'
import { useFocusOnElement } from 'hooks/useFocusOnElement'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

export interface TimeoutMessageProps {
}

export const TimeoutMessage: FC<TimeoutMessageProps> = () => {
  const focusRef = useFocusOnElement()
  const { t } = useTranslation('mcfStep0Page')

  return (
    <Alert
      hideIcon
      role='alert'
      variation='error'
      className='my-u-my--20'
      tabIndex={-1}
      alertRef={focusRef}
    >
      <p className='my-u-m--0'>{t('timeoutError')}</p>
    </Alert>
  )
}
